import { render } from "./GeneralStatisticsPage.vue?vue&type=template&id=e02514d0&scoped=true"
import script from "./GeneralStatisticsPage.vue?vue&type=script&lang=js"
export * from "./GeneralStatisticsPage.vue?vue&type=script&lang=js"

import "./GeneralStatisticsPage.vue?vue&type=style&index=0&id=e02514d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e02514d0"]])

export default __exports__